import React, { useState } from 'react';

import SatCheckBox from '@components/common/satUI/SatCheckBox';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';

const DiagnosisDetail = props => {
  const {
    showErrorCheckMsg,
    addDiagnosisCode,
    setAddDiagnosisCode,
    diagnosisCode,
  } = props;

  const [itemOpen, setItemOpen] = useState(false);

  // 일반검사 check 항목
  const general = [
    { label: '일반혈액검사(CBC)', value: '8' },
    { label: '혈당(Glucose)', value: '21' },
    { label: '당화혈색소(HbA1C)', value: '22' },
    { label: '니코틴(Nicotine Test)', value: '46' },
    { label: '뇨검사(Urine Test)(방문검진)', value: '47' },
  ];

  // 고지혈증 check 항목
  const hyperlipidemia = [
    { label: '콜레스테롤 (Cholesterol)', value: '23' },
    { label: '중성지방 (Triglyceride)', value: '25' },
    { label: 'HDL 콜레스테롤 (HDL-Cholesterol)', value: '24' },
  ];

  // 간검사 check 항목
  const liver = [
    { label: 'B형간염 표면항원 (HBsAg)', value: '16' },
    { label: 'B형간염 표면항체 (HBsAb)', value: '72' },
    { label: 'B형간염 e항원 (HBeAg)', value: '18' },
    { label: 'B형간염 정밀검사 (HBV DNA)', value: '69' },
    { label: '간기능 (GOT, GPT, r-GPT)', value: '39' },
    { label: 'C형간염 (HCV-Ab)', value: '20' },
    { label: 'C형간염 정밀검사 (HCV RNA PCR)', value: '70' },
    { label: '간암표지자 (AFP)', value: '30' },
  ];

  // 간검사 check 항목
  const thyroidKidney = [
    { label: '갑상선기능 (T4, TSH)', value: '28' },
    { label: '신장기능 (BUN, Creatinine)', value: '49' },
  ];

  // 기타 check 항목
  const etc = [
    { label: '류마티스인자 (RF)', value: '32' },
    { label: '전립선특이항원 (PSA)', value: '52' },
    { label: '요산(통풍) (Uric Acid)', value: '51' },
    { label: '고감도 C반응 단백질 (Hs-CRP)', value: '62' },
    { label: '심장 펩타이드 (NT-proBNP)', value: '63' },
    { label: '알카리포스파타제 (APL)', value: '15' },
    { label: '매독 (VDRL)', value: '29' },
    { label: '매독 정밀검사 (FTA-ABS)', value: '71' },
    { label: '에이즈 (HIV)', value: '31' },
  ];

  // 체크박스
  const handleOnCheckBox = (optionValue, value) => {
    if (value) {
      // 체크
      if (addDiagnosisCode.length < 5) {
        const newData = [...addDiagnosisCode];
        newData.push(optionValue);
        setAddDiagnosisCode(newData);
      }
    } else {
      // 체크해제
      const newData = addDiagnosisCode.filter(item => item !== optionValue);
      setAddDiagnosisCode(newData);
    }
  };

  return (
    <React.Fragment>
      <div className="infor-list detail-open">
        <div
          className="tit-area"
          onClick={() => setItemOpen(itemOpen ? false : true)}
        >
          <h2 className="tit-con">항목추가</h2>
          <span className={itemOpen ? 'btn-close' : 'btn-open'} />
        </div>
        <SatValidationErrMsg
          visible={
            showErrorCheckMsg &&
            diagnosisCode === '' &&
            addDiagnosisCode.length === 0
          }
          type="error"
          message="내용을 확인하고 선택해 주세요."
        />
        {itemOpen && (
          <>
            <p className="text-con mgb-16">최대 5개까지 선택가능합니다.</p>
            <h3 className="tit-small mgt-0">일반 검사</h3>
            <div className="check-box w100">
              {general.map(option => {
                return (
                  <>
                    <SatCheckBox
                      value={[
                        addDiagnosisCode.includes(option.value) ? true : false,
                      ]}
                      options={[{ label: option.label, value: option.value }]}
                      onChange={value => handleOnCheckBox(option.value, value)}
                      disabled={
                        addDiagnosisCode.length >= 5 &&
                        !addDiagnosisCode.includes(option.value)
                          ? true
                          : false
                      }
                    />
                  </>
                );
              })}
            </div>
            <h3 className="tit-small">고지혈증 검사</h3>
            <div className="check-box w100">
              {hyperlipidemia.map(option => {
                return (
                  <>
                    <SatCheckBox
                      value={[
                        addDiagnosisCode.includes(option.value) ? true : false,
                      ]}
                      options={[{ label: option.label, value: option.value }]}
                      onChange={value => handleOnCheckBox(option.value, value)}
                      disabled={
                        addDiagnosisCode.length >= 5 &&
                        !addDiagnosisCode.includes(option.value)
                          ? true
                          : false
                      }
                    />
                  </>
                );
              })}
            </div>
            <h3 className="tit-small">간기능 및 간염 검사</h3>
            <div className="check-box w100">
              {liver.map(option => {
                return (
                  <>
                    <SatCheckBox
                      value={[
                        addDiagnosisCode.includes(option.value) ? true : false,
                      ]}
                      options={[{ label: option.label, value: option.value }]}
                      onChange={value => handleOnCheckBox(option.value, value)}
                      disabled={
                        addDiagnosisCode.length >= 5 &&
                        !addDiagnosisCode.includes(option.value)
                          ? true
                          : false
                      }
                    />
                  </>
                );
              })}
            </div>
            <h3 className="tit-small">갑상선 및 신장기능 검사</h3>
            <div className="check-box w100">
              {thyroidKidney.map(option => {
                return (
                  <>
                    <SatCheckBox
                      value={[
                        addDiagnosisCode.includes(option.value) ? true : false,
                      ]}
                      options={[{ label: option.label, value: option.value }]}
                      onChange={value => handleOnCheckBox(option.value, value)}
                      disabled={
                        addDiagnosisCode.length >= 5 &&
                        !addDiagnosisCode.includes(option.value)
                          ? true
                          : false
                      }
                    />
                  </>
                );
              })}
            </div>
            <h3 className="tit-small">기타 검사</h3>
            <div className="check-box w100">
              {etc.map(option => {
                return (
                  <>
                    <SatCheckBox
                      value={[
                        addDiagnosisCode.includes(option.value) ? true : false,
                      ]}
                      options={[{ label: option.label, value: option.value }]}
                      onChange={value => handleOnCheckBox(option.value, value)}
                      disabled={
                        addDiagnosisCode.length >= 5 &&
                        !addDiagnosisCode.includes(option.value)
                          ? true
                          : false
                      }
                    />
                  </>
                );
              })}
            </div>
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default DiagnosisDetail;
